import api from "@/services/api"
import type { Product } from "../sharedTypes/products"
import { useQuery } from "@tanstack/vue-query"
import type { MaybeRef } from "@vueuse/core"
import { queryClient } from "@/queryClient"
import { BASE_PRODUCTS_QUERY_KEY } from "@/services/queryKeys"

export const listProducts = async (): Promise<
  Product[]
> => {
  const response = await api.get<Product[]>(
    "/products/products/"
  )
  return response.body
}

export const useProducts = (
  parentCategoryId?: MaybeRef<string | null | undefined>
) => {
  const { data: allProducts, ...useQueryReturns } =
    useQuery(
      [BASE_PRODUCTS_QUERY_KEY],
      () => listProducts(),
      {
        staleTime: 60 * 60 * 1000,
        queryClient,
      }
    )

  const data = computed(() =>
    unref(parentCategoryId) === undefined
      ? allProducts.value
      : allProducts.value?.filter(
          (product) =>
            product.parentCategoryId ===
            unref(parentCategoryId)
        )
  )

  return {
    allProducts: allProducts,
    data: data,
    ...useQueryReturns,
  }
}

export const prefetchProducts = async () => {
  await queryClient.prefetchQuery(
    [BASE_PRODUCTS_QUERY_KEY],
    listProducts,
    { staleTime: 60 * 60 * 1000 }
  )
}
